import { DEALER_FEE_CONFIGURATIONS } from 'site-modules/shared/constants/inventory/prices';

const hasAdvertisedPrice = vinData => Number(vinData?.prices?.advertisedPrice) > 0;

export const hasDealerFees = vinData =>
  vinData?.prices?.feeConfigurationType === DEALER_FEE_CONFIGURATIONS.HAS_FEES && hasAdvertisedPrice(vinData);

export const hasNoDealerFees = vinData =>
  vinData?.prices?.feeConfigurationType === DEALER_FEE_CONFIGURATIONS.NO_FEES && hasAdvertisedPrice(vinData);

export const hasUnknownDealerFees = vinData =>
  (!vinData?.prices?.feeConfigurationType ||
    vinData?.prices?.feeConfigurationType === DEALER_FEE_CONFIGURATIONS.UNKNOWN) &&
  hasAdvertisedPrice(vinData);
